import React, { FC, useCallback } from 'react'
import { useCreateSection75Dispute } from '../../hooks'
import { useConsumerSizes } from '../../../../../utils/responsive'
import { Button, Heading, Icon, Modal, Text } from '@afterpaytouch/core'
import { useSection75DisputeModalContext } from '../../Section75DisputeModalContext'
import { useTranslation } from 'next-i18next'

const I18N_NAMESPACE = ['dispute']

export const Review: FC = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { textSize } = useConsumerSizes()
  const { closeModal } = useSection75DisputeModalContext()
  const createDispute = useCreateSection75Dispute()

  const backHandler = useCallback(() => {
    closeModal()
  }, [closeModal])

  return (
    <>
      <Modal.Header divider={true}>
        <div className='absolute z-10 pt-1'>
          <Button.Link size='Small' onClick={backHandler}>
            <Icon.CaretLeft size='Small' />
          </Button.Link>
        </div>
        <div className='text-center'>
          <Heading size='L'>{t('dispute:section75DisputeModal:review:heading')}</Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div>
          <Text size={textSize}>{t('dispute:section75DisputeModal:review:description')}</Text>
        </div>
        <div className='mt-4'>
          <Button padding='Fluid' size='Large' onClick={createDispute}>
            {t('dispute:section75DisputeModal:review:submit')}
          </Button>
        </div>
      </Modal.Content>
    </>
  )
}
